































import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import { Function, Post } from "../../Classes/Entities";
import { PostList } from "../../Classes/Entities/Chat/PostList";
import { PostFactory } from '../../Classes/Entities/Chat/PostFactory';
import { ThreadFirstPost } from "../../Classes/Entities/Chat/ThreadFirstPost";

@Component
export default class Task extends Vue {
  @Prop() 
  public function!: Function<Post>;

  @Emit()
  public input(value:string){
  }

  public get id():string {
    return this.function.id;
  }
  
  private get name(): string {
    return this.function.name;
  }
  
  private set name(value:string) {
  }
}
